import { render, staticRenderFns } from "./POUserElement.vue?vue&type=template&id=465a4411"
import script from "./POUserElement.vue?vue&type=script&lang=js"
export * from "./POUserElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports